import { AggregatedUserWidget, TargetPage, WidgetComponentType } from '@markant-platform/widgets/model';
import { Route } from '@angular/router';
import {
  startsWith,
  WebComponentWrapper,
  WebComponentWrapperOptions,
} from '@angular-architects/module-federation-tools';
import { cleanUrl } from '@markant-platform/shared/util-helpers';

export const getWidgetsByComponentType = (
  widgets: AggregatedUserWidget[],
  type: WidgetComponentType
): AggregatedUserWidget[] => {
  return widgets.filter(widget => widget.widgetComponent.type === type);
};
export const buildTargetPageRoutes = (widgets: AggregatedUserWidget[]): Route[] => {
  const externalServicesWithPlatformOpening = widgets.filter(widget => widget.targetPage?.openOn === 'PLATFORM');

  return externalServicesWithPlatformOpening.map(widget => {
    const { displayName, widgetEntrypoint, targetPage } = widget;

    return {
      title: displayName,
      matcher: startsWith(cleanUrl((targetPage as TargetPage).routePath)),
      component: WebComponentWrapper,
      data: {
        title: displayName,
        type: 'module',
        remoteEntry: widgetEntrypoint,
        exposedModule: (targetPage as TargetPage).exposedPath,
        elementName: (targetPage as TargetPage).componentName,
      } as WebComponentWrapperOptions & { title: string },
    };
  });
};
